import Bills from 'assets/brand/bills.png';
import Bolt from 'assets/brand/bolt.png';
import Book from 'assets/brand/book.png';
import HeartBox from 'assets/brand/box.png';
import FloatingCash from 'assets/brand/cash.png';
import ChillDude from 'assets/brand/chill.png';
import AlarmClock from 'assets/brand/clock.png';
import Cup from 'assets/brand/cup.png';
import Earth from 'assets/brand/earth.png';
import Fireworks from 'assets/brand/fireworks.png';
import RaceFlag from 'assets/brand/flag.png';
import Flower from 'assets/brand/flower.png';
import Invoice from 'assets/brand/invoice.png';
import Notepad from 'assets/brand/notepad.png';
import Plant from 'assets/brand/plant.png';
import Receipt from 'assets/brand/receipt.png';
import CashRegister from 'assets/brand/register.png';
import Safe from 'assets/brand/safe.png';
import Shield from 'assets/brand/shield.png';
import Teapot from 'assets/brand/teapot.png';
import Wallet from 'assets/brand/wallet.png';

export type BankAccountIllustrationsType = typeof BANK_ACCOUNT_ILLUSTRATIONS;

export const BANK_ACCOUNT_ILLUSTRATIONS = {
  'alarm-clock': AlarmClock,
  bills: Bills,
  bolt: Bolt,
  book: Book,
  'cash-register': CashRegister,
  'chill-dude': ChillDude,
  cup: Cup,
  earth: Earth,
  fireworks: Fireworks,
  'floating-cash': FloatingCash,
  'flower-with-dome': Flower,
  'heart-box': HeartBox,
  invoice: Invoice,
  notepad: Notepad,
  plant: Plant,
  'race-flag': RaceFlag,
  receipt: Receipt,
  safe: Safe,
  shield: Shield,
  teapot: Teapot,
  wallet: Wallet,
};

export const PICKABLE_ILLUSTRATIONS = Object.keys(
  BANK_ACCOUNT_ILLUSTRATIONS,
).filter((name) => name !== 'wallet');
